var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

//@ts-check
var react = require('react');

module.exports = function UseStateRef(defaultValue) {
  var _react$useState = react.useState(defaultValue),
      _react$useState2 = _slicedToArray(_react$useState, 2),
      state = _react$useState2[0],
      setState = _react$useState2[1];

  var ref = react.useRef(defaultValue);
  ref.current = state;
  return [state, function (newValue) {
    ref.current = newValue;
    return setState(newValue);
  }, ref];
};